import { Injectable } from '@angular/core';
import { FormExtractorService } from '../../../../shared/services/form-extractor.service';
import { FacturationADService } from '../../../adapte/services/facturation.service';
import { TypeAdresseTEMPOST } from '../../models/type.adresse.tempost';
import { TypeFacturation } from '../../models/type.facturation';
import { RadioCheckBoxEnum } from '../../radio.checkbox.enums';
import { ClasseProfit } from '../../models/classe.profit';
import { EformsExtractorService } from '../../../eforms/services/eforms-extractor.service';
import { TypeFacturation as TypeFacturationDila } from 'src/app/models/eforms/dila/TypeFacturation';
import { AvisDataTransferService } from '../../../../shared/services/avis-data-transfer.service';
import { EMPTY, Observable } from 'rxjs';
import { expand, reduce } from 'rxjs/operators';
import { Siret } from '../../../../../models/siret';
import { TypeEntiteResponse } from '../../../../../models/typeEntiteResponse';
import { IdentifiantAdressageData } from '../../../../../models/identifiantAdressageData';
import { IdentifiantsAdressageResponse } from '../../../../../models/identifiantsAdressageResponse';
import { HttpService } from '../../../../shared/services/http.service';
import { Endpoints } from '../../../../../models/endpoints';


@Injectable({
  providedIn: 'root'
})
export class FacturationService {

  constructor(private facturationADService: FacturationADService,
              private formExtractorService: FormExtractorService,
              private eformsExtractorService: EformsExtractorService,
              private avisDataTransferService: AvisDataTransferService,
              private http: HttpService) {
  }

  public getFacturation(form: any, formName: string, controls: any): TypeFacturation {
    let typeFacturation: any;

    if (formName?.includes('SIMP') || formName?.includes('DIV') || formName?.includes('MAPA')) {
      typeFacturation = this.Fact(form);
    } else if (formName?.includes('E_FORM')) {
      typeFacturation = <TypeFacturationDila> this.eformsExtractorService.getFacturation(form);
    } else {
      typeFacturation = this.facturationADService.getFacturation(form);
    }

    return typeFacturation;
  }

  Fact(form): TypeFacturation {
    const typeFacturation: TypeFacturation = new TypeFacturation();
    let facturation = this.avisDataTransferService.avis?.jsonSaisieFormulaire?.ann?.facturation;

    typeFacturation.noServiceExecutant = form.controls._SepSep_TypeFacturation_SepAtt_noServiceExecutant?.value;
    if (typeFacturation.noServiceExecutant === null && facturation?.noServiceExecutant) {
      typeFacturation.noServiceExecutant = facturation.noServiceExecutant;
      form.controls._SepSep_TypeFacturation_SepAtt_noServiceExecutant.value = facturation?.noServiceExecutant;
    }
    typeFacturation.libelle = new TypeAdresseTEMPOST();
    typeFacturation.libelle.adr1 = form.controls._SepSep_TypeFacturation_SepSep_TypeAdresseTEMPOST_SepAtt_adr1?.value;
    if (typeFacturation.libelle.adr1 === null && facturation?.libelle && facturation?.libelle?.adr1) {
      typeFacturation.libelle.adr1 = facturation.libelle.adr1;
      form.controls._SepSep_TypeFacturation_SepSep_TypeAdresseTEMPOST_SepAtt_adr1.value = facturation?.libelle?.adr1;
    }
    typeFacturation.libelle.adr2 = form.controls._SepSep_TypeFacturation_SepSep_TypeAdresseTEMPOST_SepAtt_adr2?.value;
    if (typeFacturation.libelle.adr2 === null && facturation?.libelle && facturation?.libelle?.adr2) {
      typeFacturation.libelle.adr2 = facturation.libelle.adr2;
      form.controls._SepSep_TypeFacturation_SepSep_TypeAdresseTEMPOST_SepAtt_adr2.value = facturation?.libelle?.adr2;
    }
    typeFacturation.libelle.adr3 = form.controls._SepSep_TypeFacturation_SepSep_TypeAdresseTEMPOST_SepAtt_adr3?.value;
    if (typeFacturation.libelle.adr3 === null && facturation?.libelle && facturation?.libelle?.adr3) {
      typeFacturation.libelle.adr3 = facturation.libelle.adr3;
      form.controls._SepSep_TypeFacturation_SepSep_TypeAdresseTEMPOST_SepAtt_adr3.value = facturation?.libelle?.adr3;
    }
    typeFacturation.libelle.adr4 = form.controls._SepSep_TypeFacturation_SepSep_TypeAdresseTEMPOST_SepAtt_adr4?.value;
    if (typeFacturation.libelle.adr4 === null && facturation?.libelle && facturation?.libelle.adr4) {
      typeFacturation.libelle.adr4 = facturation.libelle.adr4;
      form.controls._SepSep_TypeFacturation_SepSep_TypeAdresseTEMPOST_SepAtt_adr4.value = facturation?.libelle?.adr4;
    }
    typeFacturation.libelle.classeProfit = new ClasseProfit();
    typeFacturation.libelle.classeProfit.autresOrganismesPublics = form.controls._SepSep_TypeFacturation_SepSep_TypeAdresseTEMPOST_SepSep_ClasseProfit_SepAtt_region?.value === RadioCheckBoxEnum.autresOrganismesPublics ? RadioCheckBoxEnum.emptyValue : null;
    typeFacturation.libelle.classeProfit.commune = form.controls._SepSep_TypeFacturation_SepSep_TypeAdresseTEMPOST_SepSep_ClasseProfit_SepAtt_region?.value === RadioCheckBoxEnum.commune ? RadioCheckBoxEnum.emptyValue : null;
    typeFacturation.libelle.classeProfit.debiteurEtranger = form.controls._SepSep_TypeFacturation_SepSep_TypeAdresseTEMPOST_SepSep_ClasseProfit_SepAtt_region?.value === RadioCheckBoxEnum.debiteurEtranger ? RadioCheckBoxEnum.emptyValue : null;
    typeFacturation.libelle.classeProfit.debiteurPrivePersMorale = form.controls._SepSep_TypeFacturation_SepSep_TypeAdresseTEMPOST_SepSep_ClasseProfit_SepAtt_region?.value === RadioCheckBoxEnum.debiteurPrivePersMorale ? RadioCheckBoxEnum.emptyValue : null;
    typeFacturation.libelle.classeProfit.debiteurPrivePersPhysique = form.controls._SepSep_TypeFacturation_SepSep_TypeAdresseTEMPOST_SepSep_ClasseProfit_SepAtt_region?.value === RadioCheckBoxEnum.debiteurPrivePersPhysique ? RadioCheckBoxEnum.emptyValue : null;
    typeFacturation.libelle.classeProfit.departement = form.controls._SepSep_TypeFacturation_SepSep_TypeAdresseTEMPOST_SepSep_ClasseProfit_SepAtt_region?.value === RadioCheckBoxEnum.departement ? RadioCheckBoxEnum.emptyValue : null;
    typeFacturation.libelle.classeProfit.etablissementsPublicsSante = form.controls._SepSep_TypeFacturation_SepSep_TypeAdresseTEMPOST_SepSep_ClasseProfit_SepAtt_region?.value === RadioCheckBoxEnum.etablissementsPublicsSante ? RadioCheckBoxEnum.emptyValue : null;
    typeFacturation.libelle.classeProfit.etat = form.controls._SepSep_TypeFacturation_SepSep_TypeAdresseTEMPOST_SepSep_ClasseProfit_SepAtt_region?.value === RadioCheckBoxEnum.etat ? RadioCheckBoxEnum.emptyValue : null;
    typeFacturation.libelle.classeProfit.groupementCollectivites = form.controls._SepSep_TypeFacturation_SepSep_TypeAdresseTEMPOST_SepSep_ClasseProfit_SepAtt_region?.value === RadioCheckBoxEnum.groupementCollectivites ? RadioCheckBoxEnum.emptyValue : null;
    typeFacturation.libelle.classeProfit.region = form.controls._SepSep_TypeFacturation_SepSep_TypeAdresseTEMPOST_SepSep_ClasseProfit_SepAtt_region?.value === RadioCheckBoxEnum.region ? RadioCheckBoxEnum.emptyValue : null;

    typeFacturation.libelle.cp = form.controls._SepSep_TypeFacturation_SepSep_TypeAdresseTEMPOST_SepAtt_cp?.value;
    if (typeFacturation.libelle.cp === null && facturation?.libelle && facturation?.libelle?.cp) {
      typeFacturation.libelle.cp = facturation.libelle.cp;
      form.controls._SepSep_TypeFacturation_SepSep_TypeAdresseTEMPOST_SepAtt_cp.value = facturation?.libelle?.cp;
    }
    typeFacturation.libelle.denomination = form.controls._SepSep_TypeFacturation_SepSep_TypeAdresseTEMPOST_SepAtt_denomination?.value;
    if (typeFacturation.libelle.denomination === null && facturation?.libelle && facturation?.libelle?.denomination) {
      typeFacturation.libelle.denomination = facturation.libelle.denomination;
      form.controls._SepSep_TypeFacturation_SepSep_TypeAdresseTEMPOST_SepAtt_denomination.value = facturation?.libelle?.denomination;
    }

    typeFacturation.libelle.pays = form.controls._SepSep_TypeFacturation_SepSep_TypeAdresseTEMPOST_SepAtt_pays?.value;
    if (typeFacturation.libelle.pays == '') {
      typeFacturation.libelle.pays = null;
    }

    typeFacturation.libelle.siret = form.controls._SepSep_TypeFacturation_SepSep_TypeAdresseTEMPOST_SepAtt_siret?.value;
    if (typeFacturation.libelle.siret === null && facturation?.libelle?.siret) {
      typeFacturation.libelle.siret = facturation.libelle.siret;
      form.controls._SepSep_TypeFacturation_SepSep_TypeAdresseTEMPOST_SepAtt_siret.value = facturation?.libelle?.siret;
    } else if (typeFacturation.libelle.siret === null && this.avisDataTransferService.siret) {
      typeFacturation.libelle.siret = this.avisDataTransferService.siret;
    }

    typeFacturation.libelle.tvaIntracommunautaire = form.controls._SepSep_TypeFacturation_SepSep_TypeAdresseTEMPOST_SepAtt_tvaIntracommunautaire?.value;
    if (typeFacturation.libelle.tvaIntracommunautaire === null && facturation?.libelle && facturation?.libelle?.tvaIntracommunautaire) {
      typeFacturation.libelle.tvaIntracommunautaire = facturation.libelle.tvaIntracommunautaire;
      form.controls._SepSep_TypeFacturation_SepSep_TypeAdresseTEMPOST_SepAtt_tvaIntracommunautaire.value = facturation?.libelle?.tvaIntracommunautaire;
    }

    typeFacturation.libelle.ville = form.controls._SepSep_TypeFacturation_SepSep_TypeAdresseTEMPOST_SepAtt_ville?.value;
    if (typeFacturation.libelle.ville === null && facturation?.libelle && facturation?.libelle?.ville) {
      typeFacturation.libelle.ville = facturation.libelle.ville;
      form.controls._SepSep_TypeFacturation_SepSep_TypeAdresseTEMPOST_SepAtt_ville.value = facturation?.libelle?.ville;
    }

    typeFacturation.numBonCommande = form.controls._SepSep_TypeFacturation_SepAtt_numBonCommande?.value;
    if (typeFacturation.numBonCommande) {
      typeFacturation.numBonCommande = typeFacturation.numBonCommande.trim();
    }
    if (typeFacturation.numBonCommande === null && facturation?.numBonCommande) {
      typeFacturation.numBonCommande = facturation.numBonCommande;
      form.controls._SepSep_TypeFacturation_SepAtt_numBonCommande.value = facturation?.numBonCommande;
    }

    typeFacturation.typeEntite = form.controls._SepSep_TypeFacturation_SepAtt_typeEntite?.value;
    if (typeFacturation.typeEntite === null && facturation?.typeEntite) {
      typeFacturation.typeEntite = facturation.typeEntite;
      form.controls._SepSep_TypeFacturation_SepAtt_typeEntite.value = facturation?.typeEntite;
    }
    if (typeFacturation.typeEntite === 'PriveeAssujettie') {
      typeFacturation.identifiantAdressage = form.controls._SepSep_TypeFacturation_SepAtt_identifiantAdressage?.value;
      if (typeFacturation.identifiantAdressage === null && facturation?.identifiantAdressage) {
        typeFacturation.identifiantAdressage = facturation.identifiantAdressage;
        form.controls._SepSep_TypeFacturation_SepAtt_identifiantAdressage.value = facturation?.identifiantAdressage;
      }
    } else {
      typeFacturation.identifiantAdressage = null;
    }

    return typeFacturation;
  }

  public getSiret(code: string): Observable<Siret> {
    return this.http.get(Endpoints.FACTU_GET_SIRET + code, Siret);
  }

  public getTypeEntite(siret: string): Observable<TypeEntiteResponse> {
    return this.http.get(Endpoints.FACTU_GET_TYPE_ENTITE + siret, TypeEntiteResponse);
  }

  // Le backend pagine la liste (G2B) : on récupère toutes les pages avant de renvoyer le résultat agrégé,
  // le composant appelant a besoin de la liste complète pour peupler la liste déroulante.
  //
  // ⚠️ Ne PAS réécrire ceci avec expand()/reduce() (ou tout autre opérateur qui attend un complete()) :
  // HttpService.process() (http.service.ts) appelle s.unsubscribe() dans son propre handler next(), ce qui
  // avale la notification complete() du HttpClient sous-jacent (next et complete arrivent l'un juste après
  // l'autre de façon synchrone ; unsubscribe() dans le next empêche le complete() suivant d'être délivré).
  // Résultat : les Observables renvoyés par HttpService (get/post/...) n'émettent jamais complete(), et tout
  // opérateur qui en dépend (reduce, toArray, last, firstValueFrom, expand+reduce...) reste bloqué en
  // silence, sans erreur ni log. La récursion manuelle ci-dessous ne s'appuie que sur next(), qui fonctionne
  // correctement, et complète elle-même l'Observable renvoyé une fois toutes les pages agrégées.
  public getIdentifiantsAdressage(siret: string): Observable<IdentifiantAdressageData[]> {
    const pageSize = 25;
    return new Observable<IdentifiantAdressageData[]>((observer) => {
      let allItems: IdentifiantAdressageData[] = [];

      const fetchPage = (page: number) => {
        this.getIdentifiantsAdressagePage(siret, page, pageSize).subscribe({
            next: (response) => {
              if (this.isSuccess(response.httpStatusCode) && response.identifiantAdressageList) {
                  allItems = [...allItems, ...response.identifiantAdressageList];
                }
              // Le compteur de page vient de la boucle locale, pas de response.pageNumber (donnée back) :
              // si le back renvoyait un pageNumber incohérent (constant, mal répercuté...), se fier à sa
              // valeur bouclerait indéfiniment sur la même page malgré totalPages > 1.
              const nextPage = page + 1;
              if (this.isSuccess(response.httpStatusCode) && response.totalPages && nextPage < response.totalPages) {
                  fetchPage(nextPage);
                } else {
                  observer.next(allItems);
                  observer.complete();
                }
            },
            error: (err) => observer.error(err)
          });
      };

      fetchPage(0);
    });
  }

  private getIdentifiantsAdressagePage(siret: string, page: number, pageSize: number): Observable<IdentifiantsAdressageResponse> {
    return this.http.get(
      Endpoints.FACTU_GET_IDENTIFIANTS_ADRESSAGE + siret + '&page=' + page + '&pageSize=' + pageSize,
      IdentifiantsAdressageResponse
    );
  }

  private isSuccess(httpStatusCode: number): boolean {
    return httpStatusCode >= 200 && httpStatusCode < 300;
  }
}
